import { Component } from '@angular/core';
import { 
  NavController
} from 'ionic-angular';

// Pages
import { InstructorAddEditPage } from './instructor-add-edit';

// Providers
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

@Component({
  selector: 'page-instructor-candidates',
  templateUrl: 'instructor-candidates.html'
})
export class InstructorCandidatesPage {
  headerData: any = {};
  instructors: any = [];

  constructor(
    public navCtrl: NavController,
    public instructorsService: InstructorsService,
    private helperCsvService: HelperCsvService
  ) {
    this.headerData.title = 'Instructor Candidates';
  }

  getInstructorCandidates()
  {
    this.instructorsService.getInstructorCandidates()
      .subscribe( data => {
        this.instructors = data;
      });
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  exportInstructorCandidates()
  {
    this.helperCsvService.exportInstructorCandidateList( this.instructors, 'Instructor Candidates Export.csv' );
  }

  ionViewWillEnter()
  {
    this.getInstructorCandidates();
  }
}


// WEBPACK FOOTER //
// ./src/pages/instructors/instructor-candidates.ts